export default {
    translation: {
        "Drip Campaigns": "Drip Campaigns",
        "drip.name": "Campaign Name",
        "drip.name_help": "Give your drip campaign a descriptive name",
        "drip.subject": "Email Subject",
        "drip.subject_help": "The subject line that will be used for emails sent in this drip campaign",
        "drip.sender": "Email Sender",
        "drip.sender_help": "Choose which sender email address will be used for this drip campaign",
        "drip.base_campaign": "Email Template",
        "drip.base_campaign_help": "Choose which email campaign will be sent to contacts in this drip sequence",
        "drip.retake_snapshot": "Refresh snapshot",
        "drip.retake_snapshot_help": "Check this to update the email content if you've edited the message",
        "drip.delay_in_hours": "Send After (Hours)",
        "drip.delay_in_hours_help": "How many hours to wait before sending this email to new contacts",
        "drip.trigger_type": "When to Enroll Contacts",
        "drip.trigger_type_help": "Choose what action will automatically add contacts to this drip campaign",
        "drip.target_group": "Limit to Group",
        "drip.target_group_help": "Select which contact group to enroll in this drip campaign",
        "drip.all_groups": "All Contacts",
        "drip.is_active": "Campaign Active",
        "drip.is_active_help": "Turn this drip campaign on or off - inactive campaigns won't enroll new contacts",
        "drip.status": "Status",
        "drip.created_at": "Created On",
        "drip.last_sent_at": "Last Email Sent",
        "drip.total_enrollments": "Total Contacts Enrolled",
        "drip.total": "Total",
        "drip.queued": "Waiting to Send",
        "drip.sent": "Successfully Sent",
        "drip.failed": "Send Failed",
        "drip.cancelled": "Cancelled",
        "drip.skipped": "Skipped",
        "drip.sent_rate": "Sent Rate",
        "drip.failure_rate": "Failure Rate",
        "drip.last_enrolled_at": "Last enrolled: %{date}",
        "drip.next_scheduled_at": "Next scheduled: %{date}",
        "drip.performance_report": "Performance Report",
        "drip.total_opens": "Total Opens",
        "drip.total_clicks": "Total Clicks",
        "drip.unique_opens": "Unique Opens",
        "drip.unique_clicks": "Unique Clicks",
        "drip.delivery_rate": "Delivery Rate",
        "drip.open_rate": "Open Rate",
        "drip.click_rate": "Click Rate",
        "drip.unsubscribe_rate": "Unsubscribe Rate",
        "drip.bounces": "Bounces",
        "drip.last_opened_at": "Last opened: %{date}",
        "drip.last_clicked_at": "Last clicked: %{date}",
        "drip.report_title": "%{name} - Campaign Report",
        "drip.create_title": "Create New Drip Campaign",
        "drip.edit_title": "Edit Drip Campaign",
        "drip.show_title": "Drip Campaign Overview",
        "drip.basic_info": "Campaign Details",
        "drip.settings": "Campaign Settings",
        "drip.timing_settings": "Timing Settings",
        "drip.trigger_settings": "Enrollment Rules",
        "drip.status_settings": "Activation Status",
        "drip.enrollment_statistics": "Performance Stats",
        "drip.list_title": "Automated Email Campaigns",
        "drip.list_subtitle": "Set up automatic email sequences that send to contacts based on triggers and delays",
        "drip.empty_state": "No drip campaigns created yet",
        "drip.empty_state_subtitle": "Create your first automated email sequence to nurture leads over time",
        "drip.validation.name_required": "Please enter a campaign name",
        "drip.validation.base_campaign_required": "Please select an email template",
        "drip.validation.delay_required": "Please specify how many hours to wait",
        "drip.validation.delay_min": "Delay must be at least 1 hour",
        "drip.validation.trigger_required": "Please choose when to enroll contacts",
        "drip.actions.activate": "Activate Campaign",
        "drip.actions.deactivate": "Deactivate Campaign",
        "drip.actions.duplicate": "Copy Campaign",
        "drip.actions.view_enrollments": "View Enrolled Contacts",
        "drip.trigger.contact_created": "New Contact Added",
        "drip.trigger.contact_created_help": "Automatically enroll contacts when they are first added to your system",
        "drip.trigger.manual_enrollment": "Manual Enrollment Only",
        "drip.trigger.manual_enrollment_help": "Only add contacts to this campaign when manually enrolled",
        "drip.status.active": "Active - Enrolling New Contacts",
        "drip.status.inactive": "Paused - Not Enrolling New Contacts",
        "drip.tooltips.drip_explanation": "Drip campaigns automatically send emails to contacts after a specified delay. Perfect for welcome sequences, follow-ups, and nurture campaigns.",
        "drip.tooltips.trigger_explanation": "Triggers determine when contacts are automatically enrolled. 'New Contact Added' enrolls contacts immediately when they join your system.",
        "drip.tooltips.delay_explanation": "The delay determines how long to wait before sending the email. For example, '72 hours' means the email sends 72 hours (3 days) after enrollment.",
        "drip.enrollment.list_title": "Contact Enrollments",
        "drip.enrollment.show_title": "Enrollment Details",
        "drip.enrollment.basic_info": "Enrollment Information",
        "drip.enrollment.timing_info": "Timing Information",
        "drip.enrollment.delivery_info": "Delivery Information",
        "drip.enrollment.campaign": "Campaign",
        "drip.enrollment.contact_email": "Contact Email",
        "drip.enrollment.scheduled_send": "Scheduled Send Time",
        "drip.enrollment.enrolled_at": "Enrolled At",
        "drip.enrollment.created_at": "Created At",
        "drip.enrollment.attempts": "Send Attempts",
        "drip.enrollment.status.label": "Status",
        "drip.enrollment.status.queued": "Waiting to Send",
        "drip.enrollment.status.sent": "Successfully Sent",
        "drip.enrollment.status.failed": "Send Failed",
        "drip.enrollment.status.cancelled": "Cancelled",
        "drip.enrollment.status.skipped": "Skipped",
        "drip.delete.confirm_title": "Delete Drip Campaign",
        "drip.delete.confirm_message": "Are you sure you want to delete the drip campaign '%{name}'? This action cannot be undone and will also remove all associated contact enrollments.",
        "drip.delete.success": "Drip campaign deleted successfully",
        "drip.delete.error": "Failed to delete drip campaign",
        "common.active": "Active",
        "common.inactive": "Inactive",

        // Attribute management translations
        "Name": "Name",
        "Slug": "Slug",
        "URL-friendly identifier (lowercase letters, numbers, and hyphens only - cannot be changed after creation)": "URL-friendly identifier (lowercase letters, numbers, and hyphens only - cannot be changed after creation)",
        "URL-friendly identifier (cannot be changed after creation)": "URL-friendly identifier (cannot be changed after creation)",

        // Campaign refresh recipients
        "Refresh recipients at send time": "Refresh recipients at send time",
        "Dynamic Recipients Enabled": "Dynamic Recipients Enabled",
        "This campaign will refresh its recipient list from current groups when sent.": "This campaign will refresh its recipient list from current groups when sent.",
        "Dynamic": "Dynamic",

        // Document Centre
        "document.document_centre": "Document Centre",
        "document.export_contacts": "Export",
        "document.export_started": "Export started. We'll notify you when it's ready.",
        "document.export_ready": "Your export is ready for download",
        "document.export_error": "Could not start export. Please try again.",
        "document.fetch_error": "Could not load documents",
        "document.download_error": "Could not download document",
        "document.download": "Download",
        "document.status": "Status",
        "document.action": "Action",
        "document.no_documents": "No documents yet",
        "document.type_contact_export": "Contact Export",
        "document.status_pending": "Pending",
        "document.status_processing": "Processing",
        "document.status_completed": "Ready",
        "document.status_failed": "Failed",
        "document.filename": "Filename"
    }
};
